import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

type TextCTAType = {
  color?: string;
  size?: 'small' | 'medium';
  isBold?: boolean;
};

type FlexContainerType = {
  direction?: string;
  justifyContent?: string;
  gap?: number;
};

export const CopyOne = styled.p<{ color?: string; isBold?: boolean }>`
  color: ${(props) => (props.color ? props.color : COLORS.grey80)};
  font-size: 16px;
  letter-spacing: 0.003px;
  line-height: 24px;
  font-family: 'Audi Type';
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
`;

export const CopyTwo = styled.p<{ color?: string }>`
  color: ${(props) => (props.color ? props.color : COLORS.grey80)};
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  font-family: 'Audi Type';
`;

export const HeadlineOrderTwo = styled.h2<{ isBold?: boolean }>`
  margin: 0;
  font-family: 'Audi Type';
  letter-spacing: 0.002px;
  font-size: 24px;
  line-height: 36px;
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
  color: ${COLORS.grey80};
  @media ${device.laptop} {
    font-size: 28px;
    line-height: 44px;
  }
  @media ${device.laptopL} {
    font-size: 32px;
    line-height: 48px;
  }
  @media ${device.desktop} {
    font-size: 36px;
    line-height: 52px;
  }
`;

export const StaticHeadlineOrderTwo = styled.h2<{ isBold?: boolean; color?: string }>`
  margin: 0;
  font-family: 'Audi Type';
  letter-spacing: 0.002px;
  font-size: 24px;
  line-height: 36px;
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
  color: ${(props) => (props.color ? props.color : COLORS.grey80)};
`;

export const HeadlineOrderThree = styled.h3<{ isBold?: boolean }>`
  margin: 0;
  font-family: 'Audi Type';
  letter-spacing: 0.001px;
  font-size: 20px;
  line-height: 32px;
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
  color: ${COLORS.grey80};
  @media ${device.laptopL} {
    font-size: 24px;
    line-height: 36px;
  }
`;

export const HeadlineOrderFour = styled(Text)`
  line-height: 24px;
  font-size: 16px;
  padding-bottom: 12px;
`;

export const TagLabel = styled.div`
  font-family: 'Audi Type';
  padding: 4px 12px;
  font-size: 12px;
  line-height: 20px;
  background-color: ${COLORS.grey5};
  display: flex;
  align-items: center;
  gap: 8px;
  width: max-content;
  color: ${COLORS.grey80};
`;

export const TextCTA = styled.div<TextCTAType>`
  cursor: pointer;
  font-family: 'Audi Type';
  border: none;
  background-color: transparent;
  font-size: ${({ size }) => (size === 'medium' ? '16px' : '12px')};
  line-height: ${({ size }) => (size === 'medium' ? '24px' : '20px')};
  color: ${(props) => (props.color ? props.color : COLORS.black)};
  border-bottom: 1px solid ${(props) => (props.color ? props.color : COLORS.black)};
  padding: 0;
  font-weight: ${({ isBold }) => (isBold ? '700' : '400')};
  padding-bottom: 2px;
`;

export const StyledText = styled(Text)<{ color?: string }>`
  color: ${(props) => props.color && props.color};
`;

export const TextAlign = styled.div<{ align?: 'start' | 'end' | 'center' }>`
  text-align: ${(props) => props.align && props.align};
`;

export const FlexContainer = styled.div<FlexContainerType>`
  display: flex;
  flex-direction: ${({ direction }) => direction ?? 'row'};
  justify-content: ${({ justifyContent }) => justifyContent ?? ''};
`;
